import styled, { css } from 'styled-components';
import { device } from './Theme';

export const StyledProjects = styled.section`
  padding: 6rem 1.8rem;

  @media ${device.tablet} {
    padding: 4.2rem 1.8rem;
  }

  @media ${device.mobile} {
    padding: 3.8rem 1.2rem;
  }
`;

export const Container = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  max-width: 1000px;
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5rem;

  @media ${device.tablet} {
    gap: 3rem;

    & > div:not(:last-child) {
      border-bottom: 1px solid rgba(31, 56, 74, 0.15);
      padding-bottom: 3rem;
    }
  }
`;

export const Heading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.heading};

  @media ${device.tablet} {
    font-size: 2.2rem;
    margin-bottom: 1.6rem;
  }

  @media ${device.mobile} {
    font-size: 1.8rem;
  }
`;

export const Card = styled.div`
  display: grid;
  grid-template-columns: 0.9fr 1fr;
  align-items: center;
  gap: 2.5rem;
  width: 100%;
  margin: 0 auto;
  position: relative;

  @media ${device.tablet} {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const Desc = styled.div`
  h3 {
    font-size: 0.85rem;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.primary};
    font-family: ${({ theme }) => theme.fonts.body};
    text-transform: uppercase;
    font-weight: 400;
  }

  h4 {
    font-family: ${({ theme }) => theme.fonts.heading};
    color: ${({ theme }) => theme.colors.heading};

    font-size: 2rem;
    font-weight: 900;
    margin-bottom: 0.8rem;
  }

  p {
    margin-bottom: 1.2rem;
  }

  @media screen and (min-width: 769px) and (max-width: 920px) {
    margin-right: -6rem;
    position: relative;
    z-index: 1;

    p {
      background: #f4f4f4;
      padding: 1rem;
      border-radius: ${({ theme }) => theme.borderRadius};
    }
  }

  @media ${device.tablet} {
    order: 1;
  }

  @media ${device.mobile} {
    h3 {
      font-size: 0.8rem;
    }
    h4 {
      font-size: 1.65rem;
      margin-bottom: 0.6rem;
    }
    p {
      font-size: 0.95rem;
      margin-bottom: 1.05rem;
      line-height: 1.65;
    }
    li {
      font-size: 0.75rem;
    }
    a {
      font-size: 0.95rem;
    }
  }
`;

export const Technologies = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.65rem;

  li {
    font-size: 0.8rem;
    color: ${({ theme }) => theme.colors.text};
    background-color: #fff;
    border: 1px solid currentColor;
    padding: 0 0.6em;
    border-radius: 1rem;
  }

  @media ${device.mobile} {
    margin-bottom: 1.5rem;
    gap: 0.6rem;

    li {
      font-size: 0.75rem;
    }
  }
`;

export const Links = styled.div`
  display: flex;
  gap: 1rem;
`;

export const LinkBtn = styled.a`
  display: flex;
  align-items: center;
  gap: 0.45em;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.primary};
  padding: 0.35em 1.25em;
  border-radius: ${({ theme }) => theme.borderRadius};
  transition: ${({ theme }) => theme.transition};
  color: ${({ theme }) => theme.colors.primary};
  color: #fff;

  &:hover,
  &:focus {
    color: #fff;
    background: ${({ theme }) => theme.colors.hoverPrimary};
    border: 1px solid ${({ theme }) => theme.colors.hoverPrimary};
  }

  ${(props) =>
    props.secondary &&
    css`
      background: none;
      color: ${({ theme }) => theme.colors.primary};

      &:hover,
      &:focus {
        background: ${({ theme }) => theme.colors.hoverSecondary};
        color: ${({ theme }) => theme.colors.primary};
        border: 1px solid ${({ theme }) => theme.colors.primary};
      }
    `};
`;

export const ImageLink = styled.a`
  overflow: hidden;
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius};

  img {
    transition: 200ms;
  }

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.25);
    transition: 200ms;
    opacity: 0;
  }

  &:hover {
    &::after {
      opacity: 1;
    }

    img {
      transform: scale(1.03);
    }
  }

  @media screen and (min-width: 980px) {
    img {
      margin-left: auto;
      max-width: 32rem;
    }
  }
`;
